import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DialogComponent, TranslationPipe } from '@prekog/common-ui';
import { CreateInvoiceDialogResult } from './createinvoicedialogresult';

@Component({
    selector: 'app-createinvoicedialog',
    templateUrl: './createinvoicedialog.component.html',
    styleUrls: ['./createinvoicedialog.component.scss'],
    standalone: true,
    imports: [MatIconModule, MatDialogModule, FormsModule, TranslationPipe, CommonModule]
})
export class CreateinvoiceDialogComponent extends DialogComponent {

    paymentOption = 'CARD';
    paymentDate = '';

    closeDialog() {
        this.reject();
    }

    createInvoice() {
        const createInvoiceDialogResult: CreateInvoiceDialogResult = {
            paymentOption: this.paymentOption,
            paymentDate: this.paymentDate
        }
        this.accept(createInvoiceDialogResult)
    }
}
